import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Footer } from "./components/Footer";
import { QuoteForm } from './components/QuoteForm';
import { QuoteText } from './components/QuoteText';
import { Header } from './components/Header';

function GetQuote() {
  return (
    <div className="App">
      <Header />
      <QuoteText />
      <QuoteForm />
      <Footer />
    </div>
  );
}

export default GetQuote;
